export default {
  SET_USER(state, user) {
    state.user = user;
  },
  REMOVE_RECORD(state, itemId) {
    const userIndex = state.user.findIndex((u) => u.id === itemId);
    state.user.splice(userIndex, 1);
  },
};
